import moment from 'moment';

import { User } from './interfaces/User';

export const convertDate = (createdAtStr: string): string => {
  const date = moment(createdAtStr);
  return date.format('dddd, MMMM D, YYYY');
};

export const convertTime = (timeStr: string): string => {
  const time = moment(timeStr, 'HH:mm:ss');
  return time.format('h:mm A');
};
export const keyFromYoutubeLiveLink = (liveLink: string): string => {
  try {
    const url = new URL(liveLink);

    if (
      url.hostname.includes('youtube.com') ||
      url.hostname.includes('youtu.be')
    ) {
      if (url.hostname === 'youtu.be') {
        return url.pathname.replace('/', '');
      }

      const videoIdFromQuery = url.searchParams.get('v');
      if (videoIdFromQuery) {
        return videoIdFromQuery;
      }

      const pathMatch = url.pathname.match(/\/(embed|live)\/([a-zA-Z0-9_-]+)/);
      if (pathMatch && pathMatch[2]) {
        return pathMatch[2];
      }
    }
  } catch (err) {
    return '';
  }

  return '';
};

export const isSubscriptionActive = (userData: User | undefined) => {
  const graceDate = userData?.subscription?.grace_days_ended_at;
  return graceDate ? new Date(graceDate) >= new Date() : false;
};

export const hasPreviouslySubscribed = (userData: User | undefined) => {
  return userData && userData?.features?.length > 0;
};
